import { render } from "./UpdateSitePlanComponent.vue?vue&type=template&id=a2001616"
import script from "./UpdateSitePlanComponent.vue?vue&type=script&lang=js"
export * from "./UpdateSitePlanComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__